import React from 'react';
import { motion } from 'framer-motion';
import { Icon } from '@iconify/react';
import { portfolioData } from '../../data/portfolioData';
import Terminal from '../ui/Terminal';

const About = ({ staggerItem }) => {
  const { title, description, image } = portfolioData.about;

  return (
    <section id="about" className="py-20 border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 transition-colors duration-300">
      <div className="container mx-auto px-6">
        <motion.div 
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={staggerItem}
          className="max-w-6xl mx-auto"
        >
          <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-16 text-center">
            <span className="underline-3d">{title}</span>
          </h2>
          
          <div className="flex flex-col lg:flex-row items-center gap-12 mb-20">
            {/* Profile Image */}
            <motion.div 
              variants={staggerItem}
              className="w-full lg:w-1/3 flex justify-center"
            >
              <div className="relative group">
                <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 to-cyan-500 rounded-2xl blur opacity-25 group-hover:opacity-50 transition duration-1000 group-hover:duration-200"></div>
                <img 
                  src={image} 
                  alt="Profile" 
                  className="relative w-64 h-64 sm:w-80 sm:h-80 object-cover rounded-2xl shadow-2xl border border-gray-200 dark:border-gray-800"
                />
              </div>
            </motion.div>

            {/* Description */}
            <motion.div 
              variants={staggerItem}
              className="w-full lg:w-2/3 flex flex-col gap-8"
            >
              <p className="text-xl md:text-2xl text-gray-600 dark:text-gray-400 leading-relaxed text-center lg:text-left">
                {description}
              </p>

              {/* Driving License & Mobility Card */}
              {portfolioData.driving && (
                <div className="bg-gray-50/80 dark:bg-gray-800/30 border border-gray-200/80 dark:border-gray-700/50 p-6 rounded-2xl text-left backdrop-blur-sm shadow-lg hover:shadow-xl hover:border-blue-500/20 transition-all duration-300">
                  <h4 className="text-lg font-bold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                    <Icon icon="mdi:license" className="text-blue-500 text-xl" />
                    {portfolioData.driving.title}
                  </h4>
                  <div className="flex flex-wrap gap-2 mt-2">
                    {portfolioData.driving.licenses.map((lic, idx) => (
                      <div key={idx} className="flex items-center gap-1.5 px-3 py-1 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-sm font-bold text-gray-800 dark:text-gray-200">
                        <Icon icon={lic.icon} className="text-blue-500 text-lg" />
                        <span className="font-mono">{lic.code}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </motion.div>
          </div>

          {/* Integrated Terminal */}
          <div className="mt-20">
            <Terminal />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
